import { getClientHost } from './client';
import { getOrCreateEncodedUUID } from './user-meta';

/**
 * POST /score-predictor/{activation_id}/view
 * Submit a view to a score predictor activation
 *
 * @param {string} activationId - The score predictor activation ID
 * @param {boolean} isGated - Whether to use the gated endpoint (SSO required)
 * @param {string} authHeader - Gated auth token (if required)
 * @returns {Promise} Resolves when the view is submitted
 */
export const sendView = (activationId, isGated, authHeader) => {
    const HOST = `${getClientHost()}${process.env.API_PATH}`;

    const endpoint = isGated
        ? `https://${HOST}/gated/selectors/${activationId}/view`
        : `https://${HOST}/selectors/${activationId}/view`;

    const userId = getOrCreateEncodedUUID();

    const headersConfig = {
        'Content-Type': 'application/json'
    };

    if (isGated && authHeader) {
        headersConfig.Authorization = authHeader;
    }

    if (!isGated && userId) {
        headersConfig['X-User-Id'] = userId;
    }

    return new Promise((resolve, reject) => {
        fetch(endpoint, {
            method: 'POST',
            headers: headersConfig
        })
            .then((response) => {
                if (
                    response.status &&
                    !response.status.toString().match(/2\d{2}/g)
                ) {
                    // Non sucessful response
                    reject(response);
                    return;
                }
                resolve(response);
            })
            .catch((error) => {
                console.error('Playbook - Poll view unsuccessful.', error);
                reject(error);
            });
    });
};
